import { useState } from 'react';
import { toast } from 'sonner';
import { businessInfo } from '../mock';
import { logError } from '../lib/logger';

const INITIAL_FORM = { name: '', email: '', phone: '', category: '', message: '' };

export function useContactSubmit() {
  const [formData, setFormData] = useState(INITIAL_FORM);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCategoryChange = (value) =>
    setFormData((prev) => ({ ...prev, category: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const apiUrl = process.env.REACT_APP_BACKEND_URL;
      const response = await fetch(`${apiUrl}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      toast.success('Message sent successfully!', {
        description: "Thank you for contacting us. We'll respond within 24 hours.",
      });
      setFormData(INITIAL_FORM);
    } catch (err) {
      logError('Contact form submit failed:', err);
      toast.error('Failed to send message', {
        description: 'Please try again or call us directly at ' + businessInfo.phone,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return { formData, isSubmitting, handleInputChange, handleCategoryChange, handleSubmit };
}
